import { COUNTRY_CODE_OPTIONS } from 'shared/constants';

/** 국적 표기와 국가번호 표기가 다른 국가들 (국적 → 국가번호 옵션) */
const COUNTRY_CODE_ALIASES: Record<string, string> = {
  'Korea, Republic of': 'Korea (+82)',
  'United States': 'USA, Canada (+1)',
  Canada: 'USA, Canada (+1)',
  'Russian Federation': 'Russia (+7)',
  'Iran, Islamic Republic of': 'Iran (+98)',
  'Brunei Darussalam': 'Brunei (+673)',
  'Syrian Arab Republic': 'Syria (+963)',
  'Tanzania, United Republic of': 'Tanzania (+255)',
  'Venezuela, Bolivarian Republic of': 'Venezuela (+58)',
  'Macedonia, Republic of': 'Macedonia (+389)',
  'Congo, Republic of the (Brazzaville)': 'Congo (+242)',
  'Congo, the Democratic Republic of the (Kinshasa)': 'Congo, Democratic Republic (+243)',
  'Gambia, The': 'Gambia (+220)',
  'Micronesia, Federated States of': 'Micronesia (+691)',
  Eswatini: 'Swaziland (+268)',
};

/** 선택한 국적에 맞는 국가번호 옵션을 찾는다 (없으면 undefined) */
export const findCountryCodeOption = (nationality: string) =>
  COUNTRY_CODE_ALIASES[nationality] ??
  COUNTRY_CODE_OPTIONS.find((option) => option.replace(/\s\(\+.*\)$/, '') === nationality);
